import {
    IonRefresher,
    IonRefresherContent,
    RefresherEventDetail,
    useIonToast,
} from '@ionic/react';
import { t } from '@lingui/macro';
import { Loadable } from 'jotai/vanilla/utils/loadable';
import React, { useCallback } from 'react';

import { IJobList } from '../../interfaces/IJob';
import { groupJobs } from '../../utils';
import LoadableContent from '../content/LoadableContent';
import Legend from './Legend';
import List from './List';

interface JobsListContainerProps {
    refresh: () => Promise<void>;
    value: Loadable<Promise<IJobList[]>>;
    viewingPastJobs: boolean;
}

const LoadableRefresherList: React.FC<JobsListContainerProps> = ({
    refresh,
    value,
    viewingPastJobs,
}) => {
    const [presentToast] = useIonToast();
    const jobs = value.state === 'hasData' ? value.data : [];

    const handleRefresh = useCallback(
        async (event: CustomEvent<RefresherEventDetail>) => {
            try {
                await refresh();
            } catch (e: any) {
                presentToast({
                    message: t`Failed to refresh the page! Please try again.`,
                    duration: 5000,
                    color: 'danger',
                    buttons: [
                        {
                            text: t`Dismiss`,
                            role: 'cancel',
                        },
                    ],
                });
            }
            event.detail.complete();
        },
        [presentToast, refresh]
    );

    return (
        <>
            <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                <IonRefresherContent refreshingSpinner="circular"></IonRefresherContent>
            </IonRefresher>
            <LoadableContent value={value}>
                <List
                    viewingPastJobs={viewingPastJobs}
                    groupedJobs={groupJobs(jobs)}
                />
                <Legend />
            </LoadableContent>
        </>
    );
};

export default LoadableRefresherList;
